/**
 * For Api Error Handling
 */

import {escapeRegExp, extendBuildJsonPath} from '../util/helpers'

export default {
  data () {
    return {
      errorsByPath: {},
      errors: []
    }
  },
  methods: {
    getPathErrors (path) {
      var skipSave = !path
      if (skipSave) {
        console.warn('Invalid path for error getter', path)
      }
      for (var i = 1, l = arguments.length; i < l; i++) {
        path = extendBuildJsonPath(path, arguments[i])
      }
      var result = this.errorsByPath[path]
      if (!result) {
        result = []
        if (!skipSave) this.$set(this.errorsByPath, path, result)
      }
      this.$set(result, '_hasErrors', !!result.length)
      const vm = this
      result._clear = function () {
        vm.clearPathErrors(path)
      }
      return result
    },
    clearAllPathErrors () {
      Object.keys(this.errorsByPath).forEach(k => {
        const errors = this.errorsByPath[k]
        while (errors.length > 0) errors.pop()
      })
    },
    clearPathErrors (path) {
      if (!path) return
      for (var i = 1, l = arguments.length; i < l; i++) {
        path = extendBuildJsonPath(path, arguments[i])
      }
      this.setPathErrors(path)
      // console.log('Cleared path errors', this.errorsByPath)
    },
    movePathErrors (path, oldIndex, newIndex) {
      if (!path) return
      const matchRegExp = new RegExp('^(' + escapeRegExp(path) + '\\[)(' + oldIndex + '|' + newIndex + ')(\\]' + '.*)$')
      const oldPath = extendBuildJsonPath(path, oldIndex)
      const newPath = extendBuildJsonPath(path, newIndex)
      const oldRegexp = new RegExp('^' + escapeRegExp(oldPath) + '($|\\.|\\[)')
      const newRegexp = new RegExp('^' + escapeRegExp(newPath) + '($|\\.|\\[)')

      const oldPaths = Object
        .entries(this.errorsByPath)
        .filter(e => e[0] && e[0].match(oldRegexp))

      if (newIndex === undefined) {
        // We're deleting one. Scoot everything down
        var i = oldIndex
        while (this.movePathErrors(path, i + 1, i)) {
          i++
        }
        return
      }

      const newPaths = Object
        .entries(this.errorsByPath)
        .filter(e => e[0] && e[0].match(newRegexp))

      const clearPaths = []

      oldPaths.forEach(e => {
        const newRepPath = e[0].replace(matchRegExp, function () {return arguments[1] + newIndex + arguments[3]})
        if (!this.errorsByPath[newRepPath]) clearPaths.push(e[0])
        this.$set(this.errorsByPath, newRepPath, e[1])
      })

      newPaths.forEach(e => {
        const oldRepPath = e[0].replace(matchRegExp, function (match, p1, p2, p3) {
          return p1 + oldIndex + p3
        })
        if (!this.errorsByPath[oldRepPath]) clearPaths.push(e[0])
        this.$set(this.errorsByPath, oldRepPath, e[1])
      })

      clearPaths.forEach(p => {
        this.clearPathErrors(p)
      })

      return !!oldPaths.length
    },
    setPathErrors (path, error) {
      if (!path) return
      console.log('setting path error', path, error, this.errorsByPath)
      const errors = this.getPathErrors(path)
      const hadError = errors.length
      // clear existing errors
      while (errors.length > 0) errors.pop()
      if (!error && hadError) {
        // Any child errors?
        console.log('Checking child errors', path, JSON.stringify(Object.entries(this.errorsByPath).filter(e => e[0] && (e[0].startsWith(path + '[') || e[0].startsWith(path + '.')))))
        const childErrors = Object
          .entries(this.errorsByPath)
          .filter(e => e[0] && (e[0].startsWith(path + '[') || e[0].startsWith(path + '.')))
          .find(e => e[1] && e[1].length)
        if (childErrors) {
          console.log('has child errors', path, '::', childErrors)
          error = 'Invalid values'
        }
      }
      if (error) {
        errors.push(error)
      }
      this.$set(errors, '_hasErrors', !!errors.length)
      if (hadError !== errors.length) {
        // Cleared or set error.  Walk it up the tree.
        const parentPaths = path.match(/^(.*)(\.[a-z0-9_]+|\[[0-9]+\])$/i)
        if (parentPaths && parentPaths[1]) {
          this.setPathErrors(parentPaths[1], error ? 'Invalid values' : error)
        }
      }
    },
    clearError (clearTarget) {
      console.warn('Clearing Error', clearTarget)
    },
    filterFieldError (fielderror, response) {
      // Overridden by component.  Do not put code here
      return false
    },
    resetFieldErrorLookup (data, keepExisting) {
      if (!keepExisting) {
        console.log('Clearing all path errors')
        this.clearAllPathErrors()
      }
    },
    setFieldError (apiFieldError, response) {
      if (apiFieldError.path && apiFieldError.name) {
        const path = apiFieldError.path + '.' + apiFieldError.name
        this.setPathErrors(path, apiFieldError.status)
        console.log('errorsByPath', path, this.errorsByPath, apiFieldError)
      }
    },
    addResourceErrorHandler (commands, beforeErrorHandler) {
      // console.log('Adding Resource Error Handlers', commands)
      const errorHandler = typeof beforeErrorHandler === 'function'
        ? (response) => {
          if (!beforeErrorHandler(response)) this.apiResourceError(response)
        }
        : this.apiResourceError
      if (Array.isArray(commands)) {
        for (let command of commands) {
          if (!command.error) command.error = errorHandler
        }
      } else if (commands && commands.command && !commands.error) {
        commands.error = errorHandler
      }
      return commands
    },
    checkApiError (response) {
      // Overridden by component.  Do not put code here
      return true
    },
    apiItemError (response) {
      if (this.checkApiError(response)) {
        this.addError(response.message)
      }
    },
    checkResourceError () {
      // Overridden by component.  Do not put code here
      return true
    },
    apiResourceError (response) {
      if (this.checkResourceError(response)) this.addError(response.message)
    },
    addError (message) {
      if (message && this.errors.indexOf(message) < 0) {
        this.errors.push(message)
      }
    },
    apiSubmitCancelled (ftresponse) {
      this.onSubmitCancelled(ftresponse)
    },
    onSubmitCancelled (ftresponse) {
      // Overridden by components
    },
    resetApiErrors () {
      this.errors = []
    }
  }
}
